import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'gatsby';
import { formatDate } from '@/utils/date';
import Image from '@/components/elements/image';
import Calender from '@/components/icons/calender';
import User from '@/components/icons/user';
import { formatUrl } from '@/utils/url';
import { getTranslatableSlug } from '@/utils/translatable-slug';

function BlogPostTile({ post, isCarouselItem }) {
	const translatedSlug = getTranslatableSlug(post, post.lang);
	const blogTitle = translatedSlug?.name || post.name;

	if (isCarouselItem) {
		return (
			<div className="bg-white rounded-lg overflow-hidden border-grey-330 border shadow-blog-tile">
				<Link to={`${formatUrl(post.full_slug)}`}>
					<div className="flex flex-col">
						<Image
							src={post.content.metadataImage.filename}
							pageContext={post}
							className="object-cover h-full w-full"
						/>

						<div className="px-4 lg:px-6 py-4 md:py-2 lg:py-2 xl:py-4 flex flex-col justify-between h-30">
							<div className="flex min-h-16">
								<p className="text-base text-left lg:text-lg leading-6 text-midnight font-semibold text-grey-800 line-clamp-3">
									{blogTitle}
								</p>
							</div>
							<div className="flex flex-col text-sm">
								<div className="flex mb-1.5">
									<Calender />
									<span className="ml-2 leading-4">{formatDate(post.first_published_at, post.lang)}</span>
								</div>
							</div>
						</div>
					</div>
				</Link>
			</div>
		);
	}
	return (
		<div className="pb-8 lg:px-8 px-4">
			<div className="mx-auto bg-white rounded-lg overflow-hidden border-grey-330 border">
				<div className="md:flex">
					<div className="md:flex-shrink-0 md:w-[40%]">
						<Link to={`${formatUrl(post.full_slug)}`}>
							<Image
								src={post.content.metadataImage.filename}
								pageContext={post}
								appearance="h-full w-full"
								objectFit="fill"
							/>
						</Link>
					</div>
					<div className="px-4 lg:px-6 py-4 md:py-2 lg:py-2 xl:py-4 flex flex-col justify-between">
						<div>
							{post.content.categories?.map((category, index) => {
								const translatedSlug = getTranslatableSlug(category, category.lang);
								const categoryName = translatedSlug?.name || category.name;

								let categorySlug = `/${post.lang}/blog${formatUrl(category.slug)}`;
								if (translatedSlug.path) {
									categorySlug = formatUrl(`${post.lang}/${translatedSlug.path}`);
								}

								return (
									<Link className="text-mariner text-sm mb-2" to={categorySlug} key={category.id}>
										{categoryName}
										{post.content.categories.length > index + 1 ? ', ' : ''}
									</Link>
								);
							})}
							<Link to={`${formatUrl(post.full_slug)}`}>
								<h3 className="font-sans text-2xl leading-8 font-semibold text-grey-800 mt-2 md:line-clamp-2">
									{blogTitle}
								</h3>
							</Link>
						</div>
						<div className="md:flex">
							<div className="flex items-center md:mr-6 ">
								<User />
								<span className="ml-2">{post.content.author.name}</span>
							</div>
							<div className="mt-1 flex items-center">
								<Calender />
								<span className="ml-2">{formatDate(post.first_published_at, post.lang)}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

BlogPostTile.propTypes = {
	post: PropTypes.shape({
		full_slug: PropTypes.string.isRequired,
		lang: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
	}),
};

export default BlogPostTile;
